<app-header text='default'></app-header>


<div id="content">
  <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
    <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [href]="getReadSpeakerURL('description')">
        <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
        <span class="rsbtn_right rsimg rsplay rspart"></span>
    </a>
</div>
  <div class="description" id="description">
    <div class="main heading" i18n="@@appTagline">
      <b>Check in and take off with<br/>the CITO Skills Checker!</b>
    </div>
    <div class="main heading" i18n>
      All in less than 10 minutes!
    </div>
    <div class="main subheading" i18n="@@appDescription">
      Check your skills with this free and confidential tool and find ways to help improve your skills in: 
    </div>
  
  
    <!--
    <div class="features container-fluid">
      <div class="row">
        <div class="col" *ngFor="let feature of FEATURES">
          <div class="row icon d-flex justify-content-center">
            <div [ngClass]="feature.color" class="box shadow gradient">
              <img src="{{ feature.icon }}" onerror="this.remove()">
            </div>
          </div>
          <div class="row text d-flex justify-content-center">
            {{ feature.text }}
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="features container-fluid">
      <div class="row">
        <div class="col-4">
          <div class="row icon d-flex justify-content-center">
            <!-- <div class="red box shadow gradient"> -->
              <div class="box">
              <fa-icon [icon]="faLaptop"></fa-icon>
            </div>
          </div>
          <div class="row text d-flex justify-content-center" i18n="@@skill-computers-simple">
            Computers
          </div>
        </div>
          <div class="col-4">
            <div class="row icon d-flex justify-content-center">
              <!-- <div class="green box shadow gradient"> -->
              <div class="box">
                <fa-icon [icon]="faCalculator"></fa-icon>
              </div>
            </div>
            <div class="row text d-flex justify-content-center" i18n="@@skill-maths-simple">
              Maths
            </div>
          </div>
          <div class="col-4">
            <div class="row icon d-flex justify-content-center">
              <!-- <div class="yellow box shadow gradient"> -->
              <div class="box">
                <fa-icon [icon]="faBookOpen"></fa-icon>
              </div>
            </div>
            <div class="row text d-flex justify-content-center" i18n="@@skill-reading-and-writing-simple">
              Reading and Writing
            </div>
          </div>
        </div>
      </div>

    <div class="main subheading" i18n>
      <b>Watch the Video</b> below and then<br/>click the <b>Get Started</b> button to check your skills! 
    </div>
  </div>
  <div id="media-container">
    <!--<button *ngIf="!isVideoLoaded; else elseIsVideoLoaded" class="button special" id="how-to-use" type="button" mdbBtn mdbWavesEffect (click)="loadVideo()"></button>-->
    <button *ngIf="!isVideoLoaded" class="button special" id="how-to-use" type="button" mdbBtn mdbWavesEffect (click)="loadVideo()">
      <span i18n>Watch the video</span><br/><fa-icon [icon]="faPlay"></fa-icon>
    </button>
    <app-media [resource]=currentResource [replay]=addReplay (ready)='mediaLoaded($event)' [texts]=IMAGE_TEXT></app-media>
  </div>
  <div id="description">
    
    <!--
    <ng-template #elseIsVideoLoaded>
      <div class="muted font-italic" [ngClass]="{'transparent': !isVideoPaused}">Press play to learn about the app</div>
    </ng-template>
    -->
    
    
    <hr>
    <div class="partners d-flex justify-content-around align-items-center">
      <img *ngFor='let partner of PARTNERS' [src]='partner.image' [alt]='partner.text'>
    </div>
  </div>
</div>
<div class="footer">
  <app-navigate-button i18n-text text="Get started" (event)="onClick()"></app-navigate-button>
</div>